<template>
  <publication-query
    :default-image-url="defaultImageUrl"
    :child-page-url="pageUrl"
  />
</template>

<script setup lang="ts">
import PublicationQuery from '@/modules/publications/PublicationQuery.vue';
import { computed } from 'vue';

const props = defineProps({
  userInput: { type: Object, default: null }
});

const defaultImageUrl = computed(() => props.userInput?.imageUrl);
const pageUrl = computed(() => props.userInput?.pageUrl);

</script>
